import { useClientIdsSelect } from '@entities/clients/heplers.ts';
import { useClients } from '@entities/clients/index.ts';
import cn from 'classnames';
import type React from 'react';
import { useMemo } from 'react';
import { MainCheckboxCheckedIcon, MainCheckboxUnCheckedIcon, Person } from '@shared/assets/index.ts';
import { formatCount } from '@shared/helpers/index.ts';
import { useAppDispatch } from '@shared/hooks';
import { openActionModal } from '@src/library/redux/modal/index.ts';
import * as st from './styles.module.scss';

interface Props {
  withActionButton?: boolean;
  withCount?: boolean;
  withButtons?: boolean;
}

export const ToolbarDynamicButtons: React.FC<Props> = ({
  withActionButton = true,
  withCount = true,
  withButtons = true,
}) => {
  const dispatch = useAppDispatch();
  const { countOfClients } = useClients();
  const {
    isSelecting,
    selectedCount: selectedClientsCount,
    toggleSelectAllClients,
    isNeedToSelectAll,
    excludedIds,
  } = useClientIdsSelect();

  const handleActions = () => {
    dispatch(openActionModal());
  };

  const selectedCount = useMemo(() => {
    if (isNeedToSelectAll) {
      const excludedIdsLength = excludedIds?.length;
      if (excludedIdsLength) {
        return countOfClients - excludedIdsLength;
      } else {
        return countOfClients;
      }
    } else {
      return selectedClientsCount;
    }
  }, [isNeedToSelectAll, excludedIds, countOfClients, selectedClientsCount]);

  const isAllSelected =
    countOfClients === selectedCount && countOfClients !== 0 && selectedCount !== 0;

  const getActionsNode = () => {
    if (isSelecting) {
      return (
        <>
          <button
            onClick={toggleSelectAllClients}
            className={cn(st.selectAllButton, isAllSelected && st.allSelected)}
          >
            {isAllSelected ? <MainCheckboxCheckedIcon /> : <MainCheckboxUnCheckedIcon />}
            <span>{'Все'}</span>
          </button>
          {withActionButton && (
            <button onClick={handleActions} className={st.textButton}>
              Действие
            </button>
          )}
        </>
      );
    }
  };

  return (
    <div className={st.wrapper}>
      {withCount && (
        <div className={st.countClients}>
          <Person />
          <div className={cn(st.count, isSelecting && st.selecting)}>
            {isSelecting ? formatCount(selectedCount) : formatCount(countOfClients)}
          </div>
        </div>
      )}
      {withButtons && getActionsNode()}
    </div>
  );
};
